import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ServicesPage from "./pages/ServicesPage";
import InsightsPage from "./pages/InsightsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import BlogArticle from "./pages/BlogArticle";
import BlogEditor from "./pages/BlogEditor";
import AdminLeads from "./pages/AdminLeads";
import AdminEnquiries from "./pages/AdminEnquiries";
import FabricPlaybook from "./pages/FabricPlaybook";
import { PrivacyPolicy, CookiePolicy, Terms } from "./pages/LegalPages";
import { ThemeProvider } from "./theme/ThemeProvider";
import { Toaster } from "./components/ui/toaster";

const useReveal = () => {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); });
      },
      { threshold: 0.12 }
    );
    const els = document.querySelectorAll(".reveal:not(.visible)");
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  });
};

const Layout = ({ children }) => {
  useReveal();
  return (
    <div className="App">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

const ScrollHandler = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollHandler />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/insights" element={<Layout><InsightsPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/case-studies/:slug" element={<Layout><CaseStudyDetail /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogArticle /></Layout>} />
          <Route path="/admin/blog" element={<BlogEditor />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/enquiries" element={<AdminEnquiries />} />
          <Route path="/fabric-playbook" element={<Layout><FabricPlaybook /></Layout>} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/terms" element={<Terms />} />
          {/* Legacy route redirects */}
          <Route path="/process" element={<Navigate to="/services" replace />} />
          <Route path="/capabilities" element={<Navigate to="/services" replace />} />
          <Route path="/industries" element={<Navigate to="/services" replace />} />
          <Route path="/case-studies" element={<Navigate to="/insights" replace />} />
          <Route path="/blog" element={<Navigate to="/insights" replace />} />
          <Route path="/faq" element={<Navigate to="/about" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
